<template>
  <div class="booth-wrapper">
    <div v-if="isFetching" class="page-loader">
      <c-loader />
    </div>

    <div v-else>
      <div class="booth">
        <div class="booth-contact-info">
          <c-button
            theme="default"
            size="sm"
            icon="fa-arrow-left"
            @click="goBack()"
          ></c-button>

          <contact-info />
        </div>

        <div class="booth-detail-info">
          <div v-if="exhibitDescription">
            <h3 class="booth-subheader">About Us</h3>

            <div class="booth-description" v-html="exhibitDescription"></div>
          </div>

          <hr v-if="exhibitDescription" />

          <div v-if="hasMaterials">
            <h3 class="booth-subheader">Exhibit Content</h3>

            <c-button
              fill
              uppercase
              theme="primary"
              icon="fa-download"
              @click="onOpenDownloadMaterialsModal()"
            >Download Materials</c-button>

            <exhibit-content-modal
              v-if="showDownloadMaterialsModal"
              :show-modal.sync="showDownloadMaterialsModal"
            />

            <hr />
          </div>

          <div v-if="additionalDates?.length">
           <meeting-schedule />

            <hr />
          </div>

          <booth-representatives v-if="boothRepresentatives?.length" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import common from "../../../helpers/common";
import ContactInfo from "./contact-info";
import ExhibitContentModal from "./exhibit-content-modal";
import BoothRepresentatives from "./booth-representatives";
import MeetingSchedule from "./meeting-schedule";

export default {
  components: {
    MeetingSchedule,
    BoothRepresentatives,
    ExhibitContentModal,
    ContactInfo
  },
  mounted() {
    common.setHeaderText('Exhibit Hall Sponsor Details');

    if (!this.hasFetchedSpeakers) {
      this.$store.dispatch("boothStore/fetchBoothInfo", {attendeeId: this.attendeeId, sponsorId: this.sponsorId});
    }
  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
      sponsorId: this.$route.params.sponsorId,

      showDownloadMaterialsModal: false,
    }
  },
  computed: {
    ...mapGetters('boothStore', [
      'booth',
      'exhibitDescription',
      'additionalDates',
      'hasMaterials',
      'isFetching',
      'hasFetchedBooth',
      'boothRepresentatives',
    ]),
  },
  methods: {
    onOpenDownloadMaterialsModal() {
      this.showDownloadMaterialsModal = true;
    },

    goBack() {
      // Prefer real browser back — this enables Vue Router's savedPosition
      if (window.history.length > 1) {
        this.$router.back();
        return;
      }

      this.$router.push({ name: 'Exhibit Hall' });
    },
  }
}
</script>

<style lang="scss" scoped>
.booth-wrapper {
  background-color: white;
  border-radius: var(--attendee-card-border-radius);
  padding: var(--attendee-gap-md);
}

.booth {
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: var(--attendee-gap-md);

  @media (max-width: 1100px) {
    grid-template-columns: 1fr 2fr;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
}

.booth-subheader {
  margin-bottom: 15px;
}

.booth-description {
  white-space: pre-wrap;
}
</style>
